/* eslint-disable */
/**
 * This file was automatically generated by scripts/routes-gen.ts.
 * DO NOT MODIFY IT BY HAND. Instead, modify the routes under static/ld/routes,
 * and run pnpm routes:gen to regenerate this file.
 *
 * If you have any questions, reach out to #ask-frontend.
 *
 */

import { generatePath, Params } from 'react-router';
import type { Squad } from '@gonfalon/types/Squad';

/**
 * Declares a union of all the routes defined in ../../../static/ld/routes/unauthenticatedRoutes.tsx.
 *
 */
export type UnauthenticatedRoute =
  | '/*'
  | '/check-your-email'
  | '/choose-organization/:email'
  | '/choose-organization/:email/:selectedOrganization/enter-password'
  | '/choose-organization/:selectedOrganization/forgot'
  | '/choose-organization/check-your-email'
  | '/choose-organization/verify-email/:email'
  | '/choose-organization/verify/:token'
  | '/enroll-mfa'
  | '/forgot'
  | '/invite/:invitationToken'
  | '/join'
  | '/join-your-organization/:token'
  | '/login'
  | '/oauth/github'
  | '/oauth/google'
  | '/oauth/vercel'
  | '/pending-invite/:token'
  | '/reset/:passwordResetToken'
  | '/signup'
  | '/signup-agentcontrol'
  | '/signup/:token'
  | '/team-uses-sso'
  | '/trial-limit'
  | '/verify-email/:email'
  | '/welcome/:token';

/**
 * Declares a mapping of routes to path params for all the routes defined in ../../../static/ld/routes/unauthenticatedRoutes.tsx.
 *
 */
export type UnauthenticatedPathParams = {
  '/*': { '*'?: string };
  '/check-your-email': {};
  '/choose-organization/:email': { email: string };
  '/choose-organization/:email/:selectedOrganization/enter-password': { email: string; selectedOrganization: string };
  '/choose-organization/:selectedOrganization/forgot': { selectedOrganization: string };
  '/choose-organization/check-your-email': {};
  '/choose-organization/verify-email/:email': { email: string };
  '/choose-organization/verify/:token': { token: string };
  '/enroll-mfa': {};
  '/forgot': {};
  '/invite/:invitationToken': { invitationToken: string };
  '/join': {};
  '/join-your-organization/:token': { token: string };
  '/login': {};
  '/oauth/github': {};
  '/oauth/google': {};
  '/oauth/vercel': {};
  '/pending-invite/:token': { token: string };
  '/reset/:passwordResetToken': { passwordResetToken: string };
  '/signup': {};
  '/signup-agentcontrol': {};
  '/signup/:token': { token: string };
  '/team-uses-sso': {};
  '/trial-limit': {};
  '/verify-email/:email': { email: string };
  '/welcome/:token': { token: string };
};

/**
 * Declares an overloaded function for each client-side route.
 *
 */
export function unauthenticatedRoute(path: '/*', params: { '*'?: string }): string;
export function unauthenticatedRoute(path: '/check-your-email'): string;
export function unauthenticatedRoute(path: '/choose-organization/:email', params: { email: string }): string;
export function unauthenticatedRoute(
  path: '/choose-organization/:email/:selectedOrganization/enter-password',
  params: { email: string; selectedOrganization: string },
): string;
export function unauthenticatedRoute(
  path: '/choose-organization/:selectedOrganization/forgot',
  params: { selectedOrganization: string },
): string;
export function unauthenticatedRoute(path: '/choose-organization/check-your-email'): string;
export function unauthenticatedRoute(
  path: '/choose-organization/verify-email/:email',
  params: { email: string },
): string;
export function unauthenticatedRoute(path: '/choose-organization/verify/:token', params: { token: string }): string;
export function unauthenticatedRoute(path: '/enroll-mfa'): string;
export function unauthenticatedRoute(path: '/forgot'): string;
export function unauthenticatedRoute(path: '/invite/:invitationToken', params: { invitationToken: string }): string;
export function unauthenticatedRoute(path: '/join'): string;
export function unauthenticatedRoute(path: '/join-your-organization/:token', params: { token: string }): string;
export function unauthenticatedRoute(path: '/login'): string;
export function unauthenticatedRoute(path: '/oauth/github'): string;
export function unauthenticatedRoute(path: '/oauth/google'): string;
export function unauthenticatedRoute(path: '/oauth/vercel'): string;
export function unauthenticatedRoute(path: '/pending-invite/:token', params: { token: string }): string;
export function unauthenticatedRoute(
  path: '/reset/:passwordResetToken',
  params: { passwordResetToken: string },
): string;
export function unauthenticatedRoute(path: '/signup'): string;
export function unauthenticatedRoute(path: '/signup-agentcontrol'): string;
export function unauthenticatedRoute(path: '/signup/:token', params: { token: string }): string;
export function unauthenticatedRoute(path: '/team-uses-sso'): string;
export function unauthenticatedRoute(path: '/trial-limit'): string;
export function unauthenticatedRoute(path: '/verify-email/:email', params: { email: string }): string;
export function unauthenticatedRoute(path: '/welcome/:token', params: { token: string }): string;
export function unauthenticatedRoute(path: string, params?: Params<string>) {
  return generatePath(path, params);
}

/**
 * Defines the ownership for all the routes defined in ../../../static/ld/routes/unauthenticatedRoutes.tsx.
 *
 */
export type UnauthenticatedRouteOwnership = {
  '/*': Squad;
  '/check-your-email': Squad;
  '/choose-organization/:email': Squad;
  '/choose-organization/:email/:selectedOrganization/enter-password': Squad;
  '/choose-organization/:selectedOrganization/forgot': Squad;
  '/choose-organization/check-your-email': Squad;
  '/choose-organization/verify-email/:email': Squad;
  '/choose-organization/verify/:token': Squad;
  '/enroll-mfa': Squad;
  '/forgot': Squad;
  '/invite/:invitationToken': Squad;
  '/join': Squad;
  '/join-your-organization/:token': Squad;
  '/login': Squad;
  '/oauth/github': Squad;
  '/oauth/google': Squad;
  '/oauth/vercel': Squad;
  '/pending-invite/:token': Squad;
  '/reset/:passwordResetToken': Squad;
  '/signup': Squad;
  '/signup-agentcontrol': Squad;
  '/signup/:token': Squad;
  '/team-uses-sso': Squad;
  '/trial-limit': Squad;
  '/verify-email/:email': Squad;
  '/welcome/:token': Squad;
};

/**
 * Declares a union of all the routes defined in ../../../static/ld/routes/appRoutes.tsx.
 *
 */
export type AppRoute =
  | '/'
  | '/*'
  | '/confirm-auth/:deviceCode'
  | '/confirm-your-email'
  | '/insights'
  | '/internal/new-hires'
  | '/launchlitely'
  | '/launchlitely/:projectKey'
  | '/product-analytics/integrations/:warehouseId'
  | '/profile'
  | '/projects/:projectKey'
  | '/projects/:projectKey/agentcontrol'
  | '/projects/:projectKey/agentcontrol-welcome'
  | '/projects/:projectKey/agentcontrol-welcome/setup-sdk'
  | '/projects/:projectKey/ai'
  | '/projects/:projectKey/ai-configs'
  | '/projects/:projectKey/ai-configs/:configKey'
  | '/projects/:projectKey/ai-configs/:configKey/monitoring'
  | '/projects/:projectKey/ai-configs/:configKey/playground'
  | '/projects/:projectKey/ai-configs/:configKey/targeting'
  | '/projects/:projectKey/ai-configs/:configKey/targeting/pending-changes'
  | '/projects/:projectKey/ai-configs/:configKey/variations'
  | '/projects/:projectKey/ai-configs/:configKey/variations/:variationKey'
  | '/projects/:projectKey/ai-configs/new'
  | '/projects/:projectKey/ai-library'
  | '/projects/:projectKey/ai-library/datasets'
  | '/projects/:projectKey/ai-library/datasets/:datasetKey'
  | '/projects/:projectKey/ai-library/judge-templates'
  | '/projects/:projectKey/ai-library/judge-templates/:templateKey'
  | '/projects/:projectKey/ai-library/models'
  | '/projects/:projectKey/ai-library/models/:configKey'
  | '/projects/:projectKey/ai-library/skills'
  | '/projects/:projectKey/ai-library/snippets'
  | '/projects/:projectKey/ai-library/snippets/:snippetKey'
  | '/projects/:projectKey/ai-library/snippets/new'
  | '/projects/:projectKey/ai-library/tool/:toolKey'
  | '/projects/:projectKey/ai-library/tools'
  | '/projects/:projectKey/ai-monitoring'
  | '/projects/:projectKey/ai-monitoring/trends'
  | '/projects/:projectKey/ai/evaluation'
  | '/projects/:projectKey/ai/evaluations'
  | '/projects/:projectKey/ai/evaluations/:evaluationId/runs/:runId'
  | '/projects/:projectKey/ai/graphs'
  | '/projects/:projectKey/ai/graphs/:graphKey'
  | '/projects/:projectKey/ai/optimize-agent'
  | '/projects/:projectKey/ai/optimize-agent/:optimizationId'
  | '/projects/:projectKey/ai/optimize-agent/:optimizationId/configuration'
  | '/projects/:projectKey/ai/optimize-agent/:optimizationId/runs'
  | '/projects/:projectKey/ai/optimize-agent/:optimizationId/runs/:runId'
  | '/projects/:projectKey/ai/optimize-agent/new'
  | '/projects/:projectKey/ai/playgrounds'
  | '/projects/:projectKey/ai/playgrounds/:evaluationId'
  | '/projects/:projectKey/ai/playgrounds/active'
  | '/projects/:projectKey/ai/playgrounds/archived'
  | '/projects/:projectKey/alerts'
  | '/projects/:projectKey/alerts/:alertId'
  | '/projects/:projectKey/alerts/:alertId/edit'
  | '/projects/:projectKey/alerts/new'
  | '/projects/:projectKey/approvals'
  | '/projects/:projectKey/approvals/:approvalRequestId'
  | '/projects/:projectKey/audit'
  | '/projects/:projectKey/audit/:auditId/*'
  | '/projects/:projectKey/compare'
  | '/projects/:projectKey/compare/:environmentPair'
  | '/projects/:projectKey/compare/:environmentPair/flags/:flagKey'
  | '/projects/:projectKey/contexts'
  | '/projects/:projectKey/contexts/instances/:instanceId'
  | '/projects/:projectKey/contexts/kinds'
  | '/projects/:projectKey/contexts/kinds/:kind/instances/:key'
  | '/projects/:projectKey/dashboards'
  | '/projects/:projectKey/dashboards/:dashboardId'
  | '/projects/:projectKey/dashboards/:dashboardId/:graphId'
  | '/projects/:projectKey/dashboards/:dashboardId/:graphId/edit'
  | '/projects/:projectKey/dashboards/:dashboardId/new'
  | '/projects/:projectKey/dashboards/new'
  | '/projects/:projectKey/data-sources'
  | '/projects/:projectKey/data-sources/assignments'
  | '/projects/:projectKey/data-sources/assignments/:dataSourceKey'
  | '/projects/:projectKey/data-sources/assignments/:dataSourceKey/configuration'
  | '/projects/:projectKey/data-sources/assignments/:dataSourceKey/connections'
  | '/projects/:projectKey/data-sources/assignments/new'
  | '/projects/:projectKey/data-sources/metrics'
  | '/projects/:projectKey/data-sources/metrics/:dataSourceKey'
  | '/projects/:projectKey/data-sources/metrics/:dataSourceKey/configuration'
  | '/projects/:projectKey/data-sources/metrics/:dataSourceKey/connections'
  | '/projects/:projectKey/data-sources/metrics/new'
  | '/projects/:projectKey/errors'
  | '/projects/:projectKey/errors/:issueId'
  | '/projects/:projectKey/errors/:issueId/instances'
  | '/projects/:projectKey/errors/:issueId/instances/:instanceId'
  | '/projects/:projectKey/experiments'
  | '/projects/:projectKey/experiments/:experimentId/details'
  | '/projects/:projectKey/experiments/:experimentKey'
  | '/projects/:projectKey/experiments/:experimentKey/analytics'
  | '/projects/:projectKey/experiments/:experimentKey/design'
  | '/projects/:projectKey/experiments/:experimentKey/design/pending-changes'
  | '/projects/:projectKey/experiments/:experimentKey/download-pdf'
  | '/projects/:projectKey/experiments/:experimentKey/exposures'
  | '/projects/:projectKey/experiments/:experimentKey/iterations'
  | '/projects/:projectKey/experiments/:experimentKey/iterations/:iterationId'
  | '/projects/:projectKey/experiments/:experimentKey/results'
  | '/projects/:projectKey/experiments/:experimentKey/results/pending-changes'
  | '/projects/:projectKey/experiments/:experimentKey/traffic'
  | '/projects/:projectKey/experiments/new'
  | '/projects/:projectKey/factory/release-coordinator'
  | '/projects/:projectKey/flags'
  | '/projects/:projectKey/flags/:flagKey'
  | '/projects/:projectKey/flags/:flagKey/add-to-code'
  | '/projects/:projectKey/flags/:flagKey/approvals/:approvalRequestId'
  | '/projects/:projectKey/flags/:flagKey/audience'
  | '/projects/:projectKey/flags/:flagKey/code-refs'
  | '/projects/:projectKey/flags/:flagKey/environment-overview'
  | '/projects/:projectKey/flags/:flagKey/environments'
  | '/projects/:projectKey/flags/:flagKey/environments/exclude-rules'
  | '/projects/:projectKey/flags/:flagKey/experiments/*'
  | '/projects/:projectKey/flags/:flagKey/feedback'
  | '/projects/:projectKey/flags/:flagKey/history'
  | '/projects/:projectKey/flags/:flagKey/history/:auditId/*'
  | '/projects/:projectKey/flags/:flagKey/insights'
  | '/projects/:projectKey/flags/:flagKey/links'
  | '/projects/:projectKey/flags/:flagKey/monitoring'
  | '/projects/:projectKey/flags/:flagKey/settings'
  | '/projects/:projectKey/flags/:flagKey/settings/archive'
  | '/projects/:projectKey/flags/:flagKey/settings/deprecate'
  | '/projects/:projectKey/flags/:flagKey/targeting'
  | '/projects/:projectKey/flags/:flagKey/targeting/conflicts/:conflictIndex'
  | '/projects/:projectKey/flags/:flagKey/targeting/exclude-rules'
  | '/projects/:projectKey/flags/:flagKey/targeting/expiring-targets'
  | '/projects/:projectKey/flags/:flagKey/targeting/expiring-targets/:expiringId'
  | '/projects/:projectKey/flags/:flagKey/targeting/pending-changes'
  | '/projects/:projectKey/flags/:flagKey/targeting/pending-changes/:pendingId'
  | '/projects/:projectKey/flags/:flagKey/variations'
  | '/projects/:projectKey/flags/:flagKey/variations/conflicts/:conflictIndex'
  | '/projects/:projectKey/flags/:flagKey/variations/pending-changes'
  | '/projects/:projectKey/flags/:flagKey/variations/pending-changes/:pendingId'
  | '/projects/:projectKey/flags/:flagKey/workflows'
  | '/projects/:projectKey/flags/:flagKey/workflows/:workflowId'
  | '/projects/:projectKey/flags/:flagKey/workflows/new'
  | '/projects/:projectKey/flags/connect'
  | '/projects/:projectKey/flags/new'
  | '/projects/:projectKey/get-started'
  | '/projects/:projectKey/get-started/invite-members'
  | '/projects/:projectKey/get-started/quickstart'
  | '/projects/:projectKey/get-started/setup-cli'
  | '/projects/:projectKey/guarded-rollouts'
  | '/projects/:projectKey/holdouts'
  | '/projects/:projectKey/holdouts/:holdoutKey'
  | '/projects/:projectKey/holdouts/:holdoutKey/design'
  | '/projects/:projectKey/holdouts/:holdoutKey/details'
  | '/projects/:projectKey/holdouts/new'
  | '/projects/:projectKey/home'
  | '/projects/:projectKey/live'
  | '/projects/:projectKey/live/flags/:flagKey'
  | '/projects/:projectKey/logs'
  | '/projects/:projectKey/metric-data-sources'
  | '/projects/:projectKey/metric-data-sources/:dataSourceKey/details'
  | '/projects/:projectKey/metric-data-sources/new'
  | '/projects/:projectKey/metrics'
  | '/projects/:projectKey/metrics/:metricKey/details'
  | '/projects/:projectKey/metrics/groups'
  | '/projects/:projectKey/metrics/groups/:metricGroupKey/details'
  | '/projects/:projectKey/metrics/groups/new'
  | '/projects/:projectKey/metrics/new'
  | '/projects/:projectKey/multi-armed-bandits'
  | '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey'
  | '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/design'
  | '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/exposures'
  | '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/iterations'
  | '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/iterations/:iterationId'
  | '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/results'
  | '/projects/:projectKey/multi-armed-bandits/new'
  | '/projects/:projectKey/observability-metrics'
  | '/projects/:projectKey/observe'
  | '/projects/:projectKey/observe/expand/:dataSourceKey/:eventKind/:eventKey'
  | '/projects/:projectKey/observe/new-metric'
  | '/projects/:projectKey/product-analytics'
  | '/projects/:projectKey/product-analytics/charts'
  | '/projects/:projectKey/product-analytics/charts/:id'
  | '/projects/:projectKey/product-analytics/charts/new'
  | '/projects/:projectKey/product-analytics/cohorts'
  | '/projects/:projectKey/product-analytics/cohorts/:id'
  | '/projects/:projectKey/product-analytics/cohorts/:id/edit'
  | '/projects/:projectKey/product-analytics/cohorts/new'
  | '/projects/:projectKey/product-analytics/dashboards'
  | '/projects/:projectKey/product-analytics/dashboards/:id'
  | '/projects/:projectKey/product-analytics/dashboards/new'
  | '/projects/:projectKey/product-analytics/events'
  | '/projects/:projectKey/product-analytics/user-activity'
  | '/projects/:projectKey/product-analytics/user-attributes'
  | '/projects/:projectKey/product-analytics/visualizations/:id'
  | '/projects/:projectKey/product-analytics/visualizations/new'
  | '/projects/:projectKey/releases'
  | '/projects/:projectKey/releases/:releasePipelineKey'
  | '/projects/:projectKey/sdk-setup'
  | '/projects/:projectKey/segments'
  | '/projects/:projectKey/segments/:segmentKey'
  | '/projects/:projectKey/segments/:segmentKey/flags'
  | '/projects/:projectKey/segments/:segmentKey/history/*'
  | '/projects/:projectKey/segments/:segmentKey/history/:auditId/*'
  | '/projects/:projectKey/segments/:segmentKey/overview'
  | '/projects/:projectKey/segments/:segmentKey/settings'
  | '/projects/:projectKey/segments/:segmentKey/targeting'
  | '/projects/:projectKey/segments/:segmentKey/targeting/exports/:exportKey'
  | '/projects/:projectKey/segments/new'
  | '/projects/:projectKey/services/:serviceName'
  | '/projects/:projectKey/sessions'
  | '/projects/:projectKey/sessions/:sessionId'
  | '/projects/:projectKey/settings'
  | '/projects/:projectKey/settings/approvals'
  | '/projects/:projectKey/settings/context-kinds'
  | '/projects/:projectKey/settings/environments'
  | '/projects/:projectKey/settings/environments/:envKey'
  | '/projects/:projectKey/settings/environments/:envKey/approval-settings'
  | '/projects/:projectKey/settings/environments/:envKey/edit'
  | '/projects/:projectKey/settings/environments/:envKey/keys'
  | '/projects/:projectKey/settings/environments/new'
  | '/projects/:projectKey/settings/flags'
  | '/projects/:projectKey/settings/lifecycle'
  | '/projects/:projectKey/settings/model-configs'
  | '/projects/:projectKey/settings/model-configs/:configKey'
  | '/projects/:projectKey/settings/observability'
  | '/projects/:projectKey/settings/observability/filter-rules/:product'
  | '/projects/:projectKey/settings/payload-filters'
  | '/projects/:projectKey/settings/payload-filters/:filterKey/edit'
  | '/projects/:projectKey/settings/release-pipelines'
  | '/projects/:projectKey/settings/release-pipelines/:releasePipelineKey'
  | '/projects/:projectKey/settings/release-pipelines/new'
  | '/projects/:projectKey/settings/releases'
  | '/projects/:projectKey/settings/releases/release-pipelines'
  | '/projects/:projectKey/settings/releases/release-pipelines/:releasePipelineKey'
  | '/projects/:projectKey/settings/releases/release-pipelines/new'
  | '/projects/:projectKey/settings/releases/release-policies'
  | '/projects/:projectKey/settings/releases/release-policies/:releasePolicyKey'
  | '/projects/:projectKey/settings/releases/release-policies/new'
  | '/projects/:projectKey/settings/views'
  | '/projects/:projectKey/settings/views/:viewKey'
  | '/projects/:projectKey/settings/views/:viewKey/link'
  | '/projects/:projectKey/settings/views/:viewKey/linked-resources'
  | '/projects/:projectKey/settings/views/:viewKey/linked-resources/:resource'
  | '/projects/:projectKey/settings/views/:viewKey/linked-resources/:resource/add'
  | '/projects/:projectKey/settings/views/:viewKey/settings'
  | '/projects/:projectKey/settings/views/new'
  | '/projects/:projectKey/settings/views/settings'
  | '/projects/:projectKey/traces'
  | '/projects/:projectKey/vega'
  | '/projects/:projectKey/vega/:conversationId'
  | '/projects/:projectKey/vega/artifacts'
  | '/projects/:projectKey/vega/artifacts/:type/:externalId'
  | '/projects/:projectKey/vega/history'
  | '/projects/:projectKey/vega/settings'
  | '/settings'
  | '/settings/applications'
  | '/settings/applications/:applicationKey'
  | '/settings/applications/:applicationKey/edit'
  | '/settings/applications/:applicationKey/history/*'
  | '/settings/applications/:applicationKey/versions'
  | '/settings/applications/:applicationKey/versions/:versionKey/support-status'
  | '/settings/applications/:applicationKey/versions/new'
  | '/settings/applications/new'
  | '/settings/authorization'
  | '/settings/authorization/oauth'
  | '/settings/authorization/oauth/:appId/review'
  | '/settings/authorization/roles/:key'
  | '/settings/authorization/tokens'
  | '/settings/authorization/tokens/:tokenId/clone'
  | '/settings/authorization/tokens/:tokenId/edit'
  | '/settings/authorization/tokens/:tokenId/reset'
  | '/settings/authorization/tokens/new'
  | '/settings/billing'
  | '/settings/billing/plans'
  | '/settings/billing/plans/confirmation'
  | '/settings/billing/plans/customize'
  | '/settings/billing/plans/review'
  | '/settings/diagnostic-usage'
  | '/settings/diagnostic-usage/details/:metric'
  | '/settings/diagnostic-usage/details/overview'
  | '/settings/escalate'
  | '/settings/general'
  | '/settings/history/*'
  | '/settings/integrations'
  | '/settings/integrations/:kind/:subscriptionId/edit'
  | '/settings/integrations/:kind/:subscriptionId/errors/view'
  | '/settings/integrations/:kind/new'
  | '/settings/integrations/:kind/show'
  | '/settings/integrations/coderefs/:id/edit'
  | '/settings/integrations/destinations/:destinationId/edit'
  | '/settings/integrations/destinations/new'
  | '/settings/integrations/sentry/show'
  | '/settings/integrations/slack/:slackHookId/edit'
  | '/settings/integrations/slack/new'
  | '/settings/integrations/webhooks/:webhookId/edit'
  | '/settings/integrations/webhooks/new'
  | '/settings/members'
  | '/settings/members/:memberId'
  | '/settings/members/:memberId/history/*'
  | '/settings/members/:memberId/permissions'
  | '/settings/members/:memberId/settings'
  | '/settings/members/:memberId/teams'
  | '/settings/members/invite/:inviteEmail?'
  | '/settings/plan-usage'
  | '/settings/plan-usage/details/:metric'
  | '/settings/plan-usage/details/overview'
  | '/settings/profile'
  | '/settings/projects'
  | '/settings/relay'
  | '/settings/relay/:id/edit'
  | '/settings/relay/new'
  | '/settings/roles'
  | '/settings/roles/:key/edit'
  | '/settings/roles/:key/view'
  | '/settings/roles/new'
  | '/settings/roles/organization'
  | '/settings/roles/organization/:key/view'
  | '/settings/roles/project'
  | '/settings/roles/project/:key/view'
  | '/settings/sdk-keys'
  | '/settings/sdks'
  | '/settings/sdks/:applicationId'
  | '/settings/security'
  | '/settings/security/saml/config'
  | '/settings/teams'
  | '/settings/teams/:teamKey'
  | '/settings/teams/:teamKey/history/*'
  | '/settings/teams/:teamKey/members'
  | '/settings/teams/:teamKey/permissions'
  | '/settings/teams/:teamKey/settings'
  | '/settings/token-limits'
  | '/settings/tokens/*'
  | '/settings/usage'
  | '/settings/usage/details/*'
  | '/verify-email';

/**
 * Declares a mapping of routes to path params for all the routes defined in ../../../static/ld/routes/appRoutes.tsx.
 *
 */
export type AppPathParams = {
  '/': {};
  '/*': { '*'?: string };
  '/confirm-auth/:deviceCode': { deviceCode: string };
  '/confirm-your-email': {};
  '/insights': {};
  '/internal/new-hires': {};
  '/launchlitely': {};
  '/launchlitely/:projectKey': { projectKey: string };
  '/product-analytics/integrations/:warehouseId': { warehouseId: string };
  '/profile': {};
  '/projects/:projectKey': { projectKey: string };
  '/projects/:projectKey/agentcontrol': { projectKey: string };
  '/projects/:projectKey/agentcontrol-welcome': { projectKey: string };
  '/projects/:projectKey/agentcontrol-welcome/setup-sdk': { projectKey: string };
  '/projects/:projectKey/ai': { projectKey: string };
  '/projects/:projectKey/ai-configs': { projectKey: string };
  '/projects/:projectKey/ai-configs/:configKey': { projectKey: string; configKey: string };
  '/projects/:projectKey/ai-configs/:configKey/monitoring': { projectKey: string; configKey: string };
  '/projects/:projectKey/ai-configs/:configKey/playground': { projectKey: string; configKey: string };
  '/projects/:projectKey/ai-configs/:configKey/targeting': { projectKey: string; configKey: string };
  '/projects/:projectKey/ai-configs/:configKey/targeting/pending-changes': { projectKey: string; configKey: string };
  '/projects/:projectKey/ai-configs/:configKey/variations': { projectKey: string; configKey: string };
  '/projects/:projectKey/ai-configs/:configKey/variations/:variationKey': {
    projectKey: string;
    configKey: string;
    variationKey: string;
  };
  '/projects/:projectKey/ai-configs/new': { projectKey: string };
  '/projects/:projectKey/ai-library': { projectKey: string };
  '/projects/:projectKey/ai-library/datasets': { projectKey: string };
  '/projects/:projectKey/ai-library/datasets/:datasetKey': { projectKey: string; datasetKey: string };
  '/projects/:projectKey/ai-library/judge-templates': { projectKey: string };
  '/projects/:projectKey/ai-library/judge-templates/:templateKey': { projectKey: string; templateKey: string };
  '/projects/:projectKey/ai-library/models': { projectKey: string };
  '/projects/:projectKey/ai-library/models/:configKey': { projectKey: string; configKey: string };
  '/projects/:projectKey/ai-library/skills': { projectKey: string };
  '/projects/:projectKey/ai-library/snippets': { projectKey: string };
  '/projects/:projectKey/ai-library/snippets/:snippetKey': { projectKey: string; snippetKey: string };
  '/projects/:projectKey/ai-library/snippets/new': { projectKey: string };
  '/projects/:projectKey/ai-library/tool/:toolKey': { projectKey: string; toolKey: string };
  '/projects/:projectKey/ai-library/tools': { projectKey: string };
  '/projects/:projectKey/ai-monitoring': { projectKey: string };
  '/projects/:projectKey/ai-monitoring/trends': { projectKey: string };
  '/projects/:projectKey/ai/evaluation': { projectKey: string };
  '/projects/:projectKey/ai/evaluations': { projectKey: string };
  '/projects/:projectKey/ai/evaluations/:evaluationId/runs/:runId': {
    projectKey: string;
    evaluationId: string;
    runId: string;
  };
  '/projects/:projectKey/ai/graphs': { projectKey: string };
  '/projects/:projectKey/ai/graphs/:graphKey': { projectKey: string; graphKey: string };
  '/projects/:projectKey/ai/optimize-agent': { projectKey: string };
  '/projects/:projectKey/ai/optimize-agent/:optimizationId': { projectKey: string; optimizationId: string };
  '/projects/:projectKey/ai/optimize-agent/:optimizationId/configuration': {
    projectKey: string;
    optimizationId: string;
  };
  '/projects/:projectKey/ai/optimize-agent/:optimizationId/runs': { projectKey: string; optimizationId: string };
  '/projects/:projectKey/ai/optimize-agent/:optimizationId/runs/:runId': {
    projectKey: string;
    optimizationId: string;
    runId: string;
  };
  '/projects/:projectKey/ai/optimize-agent/new': { projectKey: string };
  '/projects/:projectKey/ai/playgrounds': { projectKey: string };
  '/projects/:projectKey/ai/playgrounds/:evaluationId': { projectKey: string; evaluationId: string };
  '/projects/:projectKey/ai/playgrounds/active': { projectKey: string };
  '/projects/:projectKey/ai/playgrounds/archived': { projectKey: string };
  '/projects/:projectKey/alerts': { projectKey: string };
  '/projects/:projectKey/alerts/:alertId': { projectKey: string; alertId: string };
  '/projects/:projectKey/alerts/:alertId/edit': { projectKey: string; alertId: string };
  '/projects/:projectKey/alerts/new': { projectKey: string };
  '/projects/:projectKey/approvals': { projectKey: string };
  '/projects/:projectKey/approvals/:approvalRequestId': { projectKey: string; approvalRequestId: string };
  '/projects/:projectKey/audit': { projectKey: string };
  '/projects/:projectKey/audit/:auditId/*': { projectKey: string; auditId: string; '*'?: string };
  '/projects/:projectKey/compare': { projectKey: string };
  '/projects/:projectKey/compare/:environmentPair': { projectKey: string; environmentPair: string };
  '/projects/:projectKey/compare/:environmentPair/flags/:flagKey': {
    projectKey: string;
    environmentPair: string;
    flagKey: string;
  };
  '/projects/:projectKey/contexts': { projectKey: string };
  '/projects/:projectKey/contexts/instances/:instanceId': { projectKey: string; instanceId: string };
  '/projects/:projectKey/contexts/kinds': { projectKey: string };
  '/projects/:projectKey/contexts/kinds/:kind/instances/:key': { projectKey: string; kind: string; key: string };
  '/projects/:projectKey/dashboards': { projectKey: string };
  '/projects/:projectKey/dashboards/:dashboardId': { projectKey: string; dashboardId: string };
  '/projects/:projectKey/dashboards/:dashboardId/:graphId': {
    projectKey: string;
    dashboardId: string;
    graphId: string;
  };
  '/projects/:projectKey/dashboards/:dashboardId/:graphId/edit': {
    projectKey: string;
    dashboardId: string;
    graphId: string;
  };
  '/projects/:projectKey/dashboards/:dashboardId/new': { projectKey: string; dashboardId: string };
  '/projects/:projectKey/dashboards/new': { projectKey: string };
  '/projects/:projectKey/data-sources': { projectKey: string };
  '/projects/:projectKey/data-sources/assignments': { projectKey: string };
  '/projects/:projectKey/data-sources/assignments/:dataSourceKey': { projectKey: string; dataSourceKey: string };
  '/projects/:projectKey/data-sources/assignments/:dataSourceKey/configuration': {
    projectKey: string;
    dataSourceKey: string;
  };
  '/projects/:projectKey/data-sources/assignments/:dataSourceKey/connections': {
    projectKey: string;
    dataSourceKey: string;
  };
  '/projects/:projectKey/data-sources/assignments/new': { projectKey: string };
  '/projects/:projectKey/data-sources/metrics': { projectKey: string };
  '/projects/:projectKey/data-sources/metrics/:dataSourceKey': { projectKey: string; dataSourceKey: string };
  '/projects/:projectKey/data-sources/metrics/:dataSourceKey/configuration': {
    projectKey: string;
    dataSourceKey: string;
  };
  '/projects/:projectKey/data-sources/metrics/:dataSourceKey/connections': {
    projectKey: string;
    dataSourceKey: string;
  };
  '/projects/:projectKey/data-sources/metrics/new': { projectKey: string };
  '/projects/:projectKey/errors': { projectKey: string };
  '/projects/:projectKey/errors/:issueId': { projectKey: string; issueId: string };
  '/projects/:projectKey/errors/:issueId/instances': { projectKey: string; issueId: string };
  '/projects/:projectKey/errors/:issueId/instances/:instanceId': {
    projectKey: string;
    issueId: string;
    instanceId: string;
  };
  '/projects/:projectKey/experiments': { projectKey: string };
  '/projects/:projectKey/experiments/:experimentId/details': { projectKey: string; experimentId: string };
  '/projects/:projectKey/experiments/:experimentKey': { projectKey: string; experimentKey: string };
  '/projects/:projectKey/experiments/:experimentKey/analytics': { projectKey: string; experimentKey: string };
  '/projects/:projectKey/experiments/:experimentKey/design': { projectKey: string; experimentKey: string };
  '/projects/:projectKey/experiments/:experimentKey/design/pending-changes': {
    projectKey: string;
    experimentKey: string;
  };
  '/projects/:projectKey/experiments/:experimentKey/download-pdf': { projectKey: string; experimentKey: string };
  '/projects/:projectKey/experiments/:experimentKey/exposures': { projectKey: string; experimentKey: string };
  '/projects/:projectKey/experiments/:experimentKey/iterations': { projectKey: string; experimentKey: string };
  '/projects/:projectKey/experiments/:experimentKey/iterations/:iterationId': {
    projectKey: string;
    experimentKey: string;
    iterationId: string;
  };
  '/projects/:projectKey/experiments/:experimentKey/results': { projectKey: string; experimentKey: string };
  '/projects/:projectKey/experiments/:experimentKey/results/pending-changes': {
    projectKey: string;
    experimentKey: string;
  };
  '/projects/:projectKey/experiments/:experimentKey/traffic': { projectKey: string; experimentKey: string };
  '/projects/:projectKey/experiments/new': { projectKey: string };
  '/projects/:projectKey/factory/release-coordinator': { projectKey: string };
  '/projects/:projectKey/flags': { projectKey: string };
  '/projects/:projectKey/flags/:flagKey': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/add-to-code': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/approvals/:approvalRequestId': {
    projectKey: string;
    flagKey: string;
    approvalRequestId: string;
  };
  '/projects/:projectKey/flags/:flagKey/audience': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/code-refs': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/environment-overview': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/environments': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/environments/exclude-rules': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/experiments/*': { projectKey: string; flagKey: string; '*'?: string };
  '/projects/:projectKey/flags/:flagKey/feedback': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/history': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/history/:auditId/*': {
    projectKey: string;
    flagKey: string;
    auditId: string;
    '*'?: string;
  };
  '/projects/:projectKey/flags/:flagKey/insights': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/links': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/monitoring': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/settings': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/settings/archive': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/settings/deprecate': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/targeting': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/targeting/conflicts/:conflictIndex': {
    projectKey: string;
    flagKey: string;
    conflictIndex: string;
  };
  '/projects/:projectKey/flags/:flagKey/targeting/exclude-rules': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/targeting/expiring-targets': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/targeting/expiring-targets/:expiringId': {
    projectKey: string;
    flagKey: string;
    expiringId: string;
  };
  '/projects/:projectKey/flags/:flagKey/targeting/pending-changes': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/targeting/pending-changes/:pendingId': {
    projectKey: string;
    flagKey: string;
    pendingId: string;
  };
  '/projects/:projectKey/flags/:flagKey/variations': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/variations/conflicts/:conflictIndex': {
    projectKey: string;
    flagKey: string;
    conflictIndex: string;
  };
  '/projects/:projectKey/flags/:flagKey/variations/pending-changes': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/variations/pending-changes/:pendingId': {
    projectKey: string;
    flagKey: string;
    pendingId: string;
  };
  '/projects/:projectKey/flags/:flagKey/workflows': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/:flagKey/workflows/:workflowId': {
    projectKey: string;
    flagKey: string;
    workflowId: string;
  };
  '/projects/:projectKey/flags/:flagKey/workflows/new': { projectKey: string; flagKey: string };
  '/projects/:projectKey/flags/connect': { projectKey: string };
  '/projects/:projectKey/flags/new': { projectKey: string };
  '/projects/:projectKey/get-started': { projectKey: string };
  '/projects/:projectKey/get-started/invite-members': { projectKey: string };
  '/projects/:projectKey/get-started/quickstart': { projectKey: string };
  '/projects/:projectKey/get-started/setup-cli': { projectKey: string };
  '/projects/:projectKey/guarded-rollouts': { projectKey: string };
  '/projects/:projectKey/holdouts': { projectKey: string };
  '/projects/:projectKey/holdouts/:holdoutKey': { projectKey: string; holdoutKey: string };
  '/projects/:projectKey/holdouts/:holdoutKey/design': { projectKey: string; holdoutKey: string };
  '/projects/:projectKey/holdouts/:holdoutKey/details': { projectKey: string; holdoutKey: string };
  '/projects/:projectKey/holdouts/new': { projectKey: string };
  '/projects/:projectKey/home': { projectKey: string };
  '/projects/:projectKey/live': { projectKey: string };
  '/projects/:projectKey/live/flags/:flagKey': { projectKey: string; flagKey: string };
  '/projects/:projectKey/logs': { projectKey: string };
  '/projects/:projectKey/metric-data-sources': { projectKey: string };
  '/projects/:projectKey/metric-data-sources/:dataSourceKey/details': { projectKey: string; dataSourceKey: string };
  '/projects/:projectKey/metric-data-sources/new': { projectKey: string };
  '/projects/:projectKey/metrics': { projectKey: string };
  '/projects/:projectKey/metrics/:metricKey/details': { projectKey: string; metricKey: string };
  '/projects/:projectKey/metrics/groups': { projectKey: string };
  '/projects/:projectKey/metrics/groups/:metricGroupKey/details': { projectKey: string; metricGroupKey: string };
  '/projects/:projectKey/metrics/groups/new': { projectKey: string };
  '/projects/:projectKey/metrics/new': { projectKey: string };
  '/projects/:projectKey/multi-armed-bandits': { projectKey: string };
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey': { projectKey: string; multiArmedBanditKey: string };
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/design': {
    projectKey: string;
    multiArmedBanditKey: string;
  };
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/exposures': {
    projectKey: string;
    multiArmedBanditKey: string;
  };
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/iterations': {
    projectKey: string;
    multiArmedBanditKey: string;
  };
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/iterations/:iterationId': {
    projectKey: string;
    multiArmedBanditKey: string;
    iterationId: string;
  };
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/results': {
    projectKey: string;
    multiArmedBanditKey: string;
  };
  '/projects/:projectKey/multi-armed-bandits/new': { projectKey: string };
  '/projects/:projectKey/observability-metrics': { projectKey: string };
  '/projects/:projectKey/observe': { projectKey: string };
  '/projects/:projectKey/observe/expand/:dataSourceKey/:eventKind/:eventKey': {
    projectKey: string;
    dataSourceKey: string;
    eventKind: string;
    eventKey: string;
  };
  '/projects/:projectKey/observe/new-metric': { projectKey: string };
  '/projects/:projectKey/product-analytics': { projectKey: string };
  '/projects/:projectKey/product-analytics/charts': { projectKey: string };
  '/projects/:projectKey/product-analytics/charts/:id': { projectKey: string; id: string };
  '/projects/:projectKey/product-analytics/charts/new': { projectKey: string };
  '/projects/:projectKey/product-analytics/cohorts': { projectKey: string };
  '/projects/:projectKey/product-analytics/cohorts/:id': { projectKey: string; id: string };
  '/projects/:projectKey/product-analytics/cohorts/:id/edit': { projectKey: string; id: string };
  '/projects/:projectKey/product-analytics/cohorts/new': { projectKey: string };
  '/projects/:projectKey/product-analytics/dashboards': { projectKey: string };
  '/projects/:projectKey/product-analytics/dashboards/:id': { projectKey: string; id: string };
  '/projects/:projectKey/product-analytics/dashboards/new': { projectKey: string };
  '/projects/:projectKey/product-analytics/events': { projectKey: string };
  '/projects/:projectKey/product-analytics/user-activity': { projectKey: string };
  '/projects/:projectKey/product-analytics/user-attributes': { projectKey: string };
  '/projects/:projectKey/product-analytics/visualizations/:id': { projectKey: string; id: string };
  '/projects/:projectKey/product-analytics/visualizations/new': { projectKey: string };
  '/projects/:projectKey/releases': { projectKey: string };
  '/projects/:projectKey/releases/:releasePipelineKey': { projectKey: string; releasePipelineKey: string };
  '/projects/:projectKey/sdk-setup': { projectKey: string };
  '/projects/:projectKey/segments': { projectKey: string };
  '/projects/:projectKey/segments/:segmentKey': { projectKey: string; segmentKey: string };
  '/projects/:projectKey/segments/:segmentKey/flags': { projectKey: string; segmentKey: string };
  '/projects/:projectKey/segments/:segmentKey/history/*': { projectKey: string; segmentKey: string; '*'?: string };
  '/projects/:projectKey/segments/:segmentKey/history/:auditId/*': {
    projectKey: string;
    segmentKey: string;
    auditId: string;
    '*'?: string;
  };
  '/projects/:projectKey/segments/:segmentKey/overview': { projectKey: string; segmentKey: string };
  '/projects/:projectKey/segments/:segmentKey/settings': { projectKey: string; segmentKey: string };
  '/projects/:projectKey/segments/:segmentKey/targeting': { projectKey: string; segmentKey: string };
  '/projects/:projectKey/segments/:segmentKey/targeting/exports/:exportKey': {
    projectKey: string;
    segmentKey: string;
    exportKey: string;
  };
  '/projects/:projectKey/segments/new': { projectKey: string };
  '/projects/:projectKey/services/:serviceName': { projectKey: string; serviceName: string };
  '/projects/:projectKey/sessions': { projectKey: string };
  '/projects/:projectKey/sessions/:sessionId': { projectKey: string; sessionId: string };
  '/projects/:projectKey/settings': { projectKey: string };
  '/projects/:projectKey/settings/approvals': { projectKey: string };
  '/projects/:projectKey/settings/context-kinds': { projectKey: string };
  '/projects/:projectKey/settings/environments': { projectKey: string };
  '/projects/:projectKey/settings/environments/:envKey': { projectKey: string; envKey: string };
  '/projects/:projectKey/settings/environments/:envKey/approval-settings': { projectKey: string; envKey: string };
  '/projects/:projectKey/settings/environments/:envKey/edit': { projectKey: string; envKey: string };
  '/projects/:projectKey/settings/environments/:envKey/keys': { projectKey: string; envKey: string };
  '/projects/:projectKey/settings/environments/new': { projectKey: string };
  '/projects/:projectKey/settings/flags': { projectKey: string };
  '/projects/:projectKey/settings/lifecycle': { projectKey: string };
  '/projects/:projectKey/settings/model-configs': { projectKey: string };
  '/projects/:projectKey/settings/model-configs/:configKey': { projectKey: string; configKey: string };
  '/projects/:projectKey/settings/observability': { projectKey: string };
  '/projects/:projectKey/settings/observability/filter-rules/:product': { projectKey: string; product: string };
  '/projects/:projectKey/settings/payload-filters': { projectKey: string };
  '/projects/:projectKey/settings/payload-filters/:filterKey/edit': { projectKey: string; filterKey: string };
  '/projects/:projectKey/settings/release-pipelines': { projectKey: string };
  '/projects/:projectKey/settings/release-pipelines/:releasePipelineKey': {
    projectKey: string;
    releasePipelineKey: string;
  };
  '/projects/:projectKey/settings/release-pipelines/new': { projectKey: string };
  '/projects/:projectKey/settings/releases': { projectKey: string };
  '/projects/:projectKey/settings/releases/release-pipelines': { projectKey: string };
  '/projects/:projectKey/settings/releases/release-pipelines/:releasePipelineKey': {
    projectKey: string;
    releasePipelineKey: string;
  };
  '/projects/:projectKey/settings/releases/release-pipelines/new': { projectKey: string };
  '/projects/:projectKey/settings/releases/release-policies': { projectKey: string };
  '/projects/:projectKey/settings/releases/release-policies/:releasePolicyKey': {
    projectKey: string;
    releasePolicyKey: string;
  };
  '/projects/:projectKey/settings/releases/release-policies/new': { projectKey: string };
  '/projects/:projectKey/settings/views': { projectKey: string };
  '/projects/:projectKey/settings/views/:viewKey': { projectKey: string; viewKey: string };
  '/projects/:projectKey/settings/views/:viewKey/link': { projectKey: string; viewKey: string };
  '/projects/:projectKey/settings/views/:viewKey/linked-resources': { projectKey: string; viewKey: string };
  '/projects/:projectKey/settings/views/:viewKey/linked-resources/:resource': {
    projectKey: string;
    viewKey: string;
    resource: string;
  };
  '/projects/:projectKey/settings/views/:viewKey/linked-resources/:resource/add': {
    projectKey: string;
    viewKey: string;
    resource: string;
  };
  '/projects/:projectKey/settings/views/:viewKey/settings': { projectKey: string; viewKey: string };
  '/projects/:projectKey/settings/views/new': { projectKey: string };
  '/projects/:projectKey/settings/views/settings': { projectKey: string };
  '/projects/:projectKey/traces': { projectKey: string };
  '/projects/:projectKey/vega': { projectKey: string };
  '/projects/:projectKey/vega/:conversationId': { projectKey: string; conversationId: string };
  '/projects/:projectKey/vega/artifacts': { projectKey: string };
  '/projects/:projectKey/vega/artifacts/:type/:externalId': { projectKey: string; type: string; externalId: string };
  '/projects/:projectKey/vega/history': { projectKey: string };
  '/projects/:projectKey/vega/settings': { projectKey: string };
  '/settings': {};
  '/settings/applications': {};
  '/settings/applications/:applicationKey': { applicationKey: string };
  '/settings/applications/:applicationKey/edit': { applicationKey: string };
  '/settings/applications/:applicationKey/history/*': { applicationKey: string; '*'?: string };
  '/settings/applications/:applicationKey/versions': { applicationKey: string };
  '/settings/applications/:applicationKey/versions/:versionKey/support-status': {
    applicationKey: string;
    versionKey: string;
  };
  '/settings/applications/:applicationKey/versions/new': { applicationKey: string };
  '/settings/applications/new': {};
  '/settings/authorization': {};
  '/settings/authorization/oauth': {};
  '/settings/authorization/oauth/:appId/review': { appId: string };
  '/settings/authorization/roles/:key': { key: string };
  '/settings/authorization/tokens': {};
  '/settings/authorization/tokens/:tokenId/clone': { tokenId: string };
  '/settings/authorization/tokens/:tokenId/edit': { tokenId: string };
  '/settings/authorization/tokens/:tokenId/reset': { tokenId: string };
  '/settings/authorization/tokens/new': {};
  '/settings/billing': {};
  '/settings/billing/plans': {};
  '/settings/billing/plans/confirmation': {};
  '/settings/billing/plans/customize': {};
  '/settings/billing/plans/review': {};
  '/settings/diagnostic-usage': {};
  '/settings/diagnostic-usage/details/:metric': { metric: string };
  '/settings/diagnostic-usage/details/overview': {};
  '/settings/escalate': {};
  '/settings/general': {};
  '/settings/history/*': { '*'?: string };
  '/settings/integrations': {};
  '/settings/integrations/:kind/:subscriptionId/edit': { kind: string; subscriptionId: string };
  '/settings/integrations/:kind/:subscriptionId/errors/view': { kind: string; subscriptionId: string };
  '/settings/integrations/:kind/new': { kind: string };
  '/settings/integrations/:kind/show': { kind: string };
  '/settings/integrations/coderefs/:id/edit': { id: string };
  '/settings/integrations/destinations/:destinationId/edit': { destinationId: string };
  '/settings/integrations/destinations/new': {};
  '/settings/integrations/sentry/show': {};
  '/settings/integrations/slack/:slackHookId/edit': { slackHookId: string };
  '/settings/integrations/slack/new': {};
  '/settings/integrations/webhooks/:webhookId/edit': { webhookId: string };
  '/settings/integrations/webhooks/new': {};
  '/settings/members': {};
  '/settings/members/:memberId': { memberId: string };
  '/settings/members/:memberId/history/*': { memberId: string; '*'?: string };
  '/settings/members/:memberId/permissions': { memberId: string };
  '/settings/members/:memberId/settings': { memberId: string };
  '/settings/members/:memberId/teams': { memberId: string };
  '/settings/members/invite/:inviteEmail?': { inviteEmail: string };
  '/settings/plan-usage': {};
  '/settings/plan-usage/details/:metric': { metric: string };
  '/settings/plan-usage/details/overview': {};
  '/settings/profile': {};
  '/settings/projects': {};
  '/settings/relay': {};
  '/settings/relay/:id/edit': { id: string };
  '/settings/relay/new': {};
  '/settings/roles': {};
  '/settings/roles/:key/edit': { key: string };
  '/settings/roles/:key/view': { key: string };
  '/settings/roles/new': {};
  '/settings/roles/organization': {};
  '/settings/roles/organization/:key/view': { key: string };
  '/settings/roles/project': {};
  '/settings/roles/project/:key/view': { key: string };
  '/settings/sdk-keys': {};
  '/settings/sdks': {};
  '/settings/sdks/:applicationId': { applicationId: string };
  '/settings/security': {};
  '/settings/security/saml/config': {};
  '/settings/teams': {};
  '/settings/teams/:teamKey': { teamKey: string };
  '/settings/teams/:teamKey/history/*': { teamKey: string; '*'?: string };
  '/settings/teams/:teamKey/members': { teamKey: string };
  '/settings/teams/:teamKey/permissions': { teamKey: string };
  '/settings/teams/:teamKey/settings': { teamKey: string };
  '/settings/token-limits': {};
  '/settings/tokens/*': { '*'?: string };
  '/settings/usage': {};
  '/settings/usage/details/*': { '*'?: string };
  '/verify-email': {};
};

/**
 * Declares an overloaded function for each client-side route.
 *
 */
export function appRoute(path: '/'): string;
export function appRoute(path: '/*', params: { '*'?: string }): string;
export function appRoute(path: '/confirm-auth/:deviceCode', params: { deviceCode: string }): string;
export function appRoute(path: '/confirm-your-email'): string;
export function appRoute(path: '/insights'): string;
export function appRoute(path: '/internal/new-hires'): string;
export function appRoute(path: '/launchlitely'): string;
export function appRoute(path: '/launchlitely/:projectKey', params: { projectKey: string }): string;
export function appRoute(path: '/product-analytics/integrations/:warehouseId', params: { warehouseId: string }): string;
export function appRoute(path: '/profile'): string;
export function appRoute(path: '/projects/:projectKey', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/agentcontrol', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/agentcontrol-welcome', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/agentcontrol-welcome/setup-sdk',
  params: { projectKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/ai', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/ai-configs', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/ai-configs/:configKey',
  params: { projectKey: string; configKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai-configs/:configKey/monitoring',
  params: { projectKey: string; configKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai-configs/:configKey/playground',
  params: { projectKey: string; configKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai-configs/:configKey/targeting',
  params: { projectKey: string; configKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai-configs/:configKey/targeting/pending-changes',
  params: { projectKey: string; configKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai-configs/:configKey/variations',
  params: { projectKey: string; configKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai-configs/:configKey/variations/:variationKey',
  params: { projectKey: string; configKey: string; variationKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/ai-configs/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/ai-library', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/ai-library/datasets', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/ai-library/datasets/:datasetKey',
  params: { projectKey: string; datasetKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai-library/judge-templates',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai-library/judge-templates/:templateKey',
  params: { projectKey: string; templateKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/ai-library/models', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/ai-library/models/:configKey',
  params: { projectKey: string; configKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/ai-library/skills', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/ai-library/snippets', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/ai-library/snippets/:snippetKey',
  params: { projectKey: string; snippetKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/ai-library/snippets/new', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/ai-library/tool/:toolKey',
  params: { projectKey: string; toolKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/ai-library/tools', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/ai-monitoring', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/ai-monitoring/trends', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/ai/evaluation', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/ai/evaluations', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/ai/evaluations/:evaluationId/runs/:runId',
  params: { projectKey: string; evaluationId: string; runId: string },
): string;
export function appRoute(path: '/projects/:projectKey/ai/graphs', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/ai/graphs/:graphKey',
  params: { projectKey: string; graphKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/ai/optimize-agent', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/ai/optimize-agent/:optimizationId',
  params: { projectKey: string; optimizationId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai/optimize-agent/:optimizationId/configuration',
  params: { projectKey: string; optimizationId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai/optimize-agent/:optimizationId/runs',
  params: { projectKey: string; optimizationId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/ai/optimize-agent/:optimizationId/runs/:runId',
  params: { projectKey: string; optimizationId: string; runId: string },
): string;
export function appRoute(path: '/projects/:projectKey/ai/optimize-agent/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/ai/playgrounds', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/ai/playgrounds/:evaluationId',
  params: { projectKey: string; evaluationId: string },
): string;
export function appRoute(path: '/projects/:projectKey/ai/playgrounds/active', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/ai/playgrounds/archived', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/alerts', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/alerts/:alertId',
  params: { projectKey: string; alertId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/alerts/:alertId/edit',
  params: { projectKey: string; alertId: string },
): string;
export function appRoute(path: '/projects/:projectKey/alerts/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/approvals', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/approvals/:approvalRequestId',
  params: { projectKey: string; approvalRequestId: string },
): string;
export function appRoute(path: '/projects/:projectKey/audit', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/audit/:auditId/*',
  params: { projectKey: string; auditId: string; '*'?: string },
): string;
export function appRoute(path: '/projects/:projectKey/compare', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/compare/:environmentPair',
  params: { projectKey: string; environmentPair: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/compare/:environmentPair/flags/:flagKey',
  params: { projectKey: string; environmentPair: string; flagKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/contexts', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/contexts/instances/:instanceId',
  params: { projectKey: string; instanceId: string },
): string;
export function appRoute(path: '/projects/:projectKey/contexts/kinds', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/contexts/kinds/:kind/instances/:key',
  params: { projectKey: string; kind: string; key: string },
): string;
export function appRoute(path: '/projects/:projectKey/dashboards', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/dashboards/:dashboardId',
  params: { projectKey: string; dashboardId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/dashboards/:dashboardId/:graphId',
  params: { projectKey: string; dashboardId: string; graphId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/dashboards/:dashboardId/:graphId/edit',
  params: { projectKey: string; dashboardId: string; graphId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/dashboards/:dashboardId/new',
  params: { projectKey: string; dashboardId: string },
): string;
export function appRoute(path: '/projects/:projectKey/dashboards/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/data-sources', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/data-sources/assignments',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/data-sources/assignments/:dataSourceKey',
  params: { projectKey: string; dataSourceKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/data-sources/assignments/:dataSourceKey/configuration',
  params: { projectKey: string; dataSourceKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/data-sources/assignments/:dataSourceKey/connections',
  params: { projectKey: string; dataSourceKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/data-sources/assignments/new',
  params: { projectKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/data-sources/metrics', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/data-sources/metrics/:dataSourceKey',
  params: { projectKey: string; dataSourceKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/data-sources/metrics/:dataSourceKey/configuration',
  params: { projectKey: string; dataSourceKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/data-sources/metrics/:dataSourceKey/connections',
  params: { projectKey: string; dataSourceKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/data-sources/metrics/new',
  params: { projectKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/errors', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/errors/:issueId',
  params: { projectKey: string; issueId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/errors/:issueId/instances',
  params: { projectKey: string; issueId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/errors/:issueId/instances/:instanceId',
  params: { projectKey: string; issueId: string; instanceId: string },
): string;
export function appRoute(path: '/projects/:projectKey/experiments', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentId/details',
  params: { projectKey: string; experimentId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey',
  params: { projectKey: string; experimentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey/analytics',
  params: { projectKey: string; experimentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey/design',
  params: { projectKey: string; experimentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey/design/pending-changes',
  params: { projectKey: string; experimentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey/download-pdf',
  params: { projectKey: string; experimentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey/exposures',
  params: { projectKey: string; experimentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey/iterations',
  params: { projectKey: string; experimentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey/iterations/:iterationId',
  params: { projectKey: string; experimentKey: string; iterationId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey/results',
  params: { projectKey: string; experimentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey/results/pending-changes',
  params: { projectKey: string; experimentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/experiments/:experimentKey/traffic',
  params: { projectKey: string; experimentKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/experiments/new', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/factory/release-coordinator',
  params: { projectKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/flags', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/add-to-code',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/approvals/:approvalRequestId',
  params: { projectKey: string; flagKey: string; approvalRequestId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/audience',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/code-refs',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/environment-overview',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/environments',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/environments/exclude-rules',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/experiments/*',
  params: { projectKey: string; flagKey: string; '*'?: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/feedback',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/history',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/history/:auditId/*',
  params: { projectKey: string; flagKey: string; auditId: string; '*'?: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/insights',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/links',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/monitoring',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/settings',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/settings/archive',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/settings/deprecate',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/targeting',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/targeting/conflicts/:conflictIndex',
  params: { projectKey: string; flagKey: string; conflictIndex: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/targeting/exclude-rules',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/targeting/expiring-targets',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/targeting/expiring-targets/:expiringId',
  params: { projectKey: string; flagKey: string; expiringId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/targeting/pending-changes',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/targeting/pending-changes/:pendingId',
  params: { projectKey: string; flagKey: string; pendingId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/variations',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/variations/conflicts/:conflictIndex',
  params: { projectKey: string; flagKey: string; conflictIndex: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/variations/pending-changes',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/variations/pending-changes/:pendingId',
  params: { projectKey: string; flagKey: string; pendingId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/workflows',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/workflows/:workflowId',
  params: { projectKey: string; flagKey: string; workflowId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/flags/:flagKey/workflows/new',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/flags/connect', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/flags/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/get-started', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/get-started/invite-members',
  params: { projectKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/get-started/quickstart', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/get-started/setup-cli', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/guarded-rollouts', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/holdouts', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/holdouts/:holdoutKey',
  params: { projectKey: string; holdoutKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/holdouts/:holdoutKey/design',
  params: { projectKey: string; holdoutKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/holdouts/:holdoutKey/details',
  params: { projectKey: string; holdoutKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/holdouts/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/home', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/live', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/live/flags/:flagKey',
  params: { projectKey: string; flagKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/logs', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/metric-data-sources', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/metric-data-sources/:dataSourceKey/details',
  params: { projectKey: string; dataSourceKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/metric-data-sources/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/metrics', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/metrics/:metricKey/details',
  params: { projectKey: string; metricKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/metrics/groups', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/metrics/groups/:metricGroupKey/details',
  params: { projectKey: string; metricGroupKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/metrics/groups/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/metrics/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/multi-armed-bandits', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey',
  params: { projectKey: string; multiArmedBanditKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/design',
  params: { projectKey: string; multiArmedBanditKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/exposures',
  params: { projectKey: string; multiArmedBanditKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/iterations',
  params: { projectKey: string; multiArmedBanditKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/iterations/:iterationId',
  params: { projectKey: string; multiArmedBanditKey: string; iterationId: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/results',
  params: { projectKey: string; multiArmedBanditKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/multi-armed-bandits/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/observability-metrics', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/observe', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/observe/expand/:dataSourceKey/:eventKind/:eventKey',
  params: { projectKey: string; dataSourceKey: string; eventKind: string; eventKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/observe/new-metric', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/product-analytics', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/charts',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/charts/:id',
  params: { projectKey: string; id: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/charts/new',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/cohorts',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/cohorts/:id',
  params: { projectKey: string; id: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/cohorts/:id/edit',
  params: { projectKey: string; id: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/cohorts/new',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/dashboards',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/dashboards/:id',
  params: { projectKey: string; id: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/dashboards/new',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/events',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/user-activity',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/user-attributes',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/visualizations/:id',
  params: { projectKey: string; id: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/product-analytics/visualizations/new',
  params: { projectKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/releases', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/releases/:releasePipelineKey',
  params: { projectKey: string; releasePipelineKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/sdk-setup', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/segments', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/segments/:segmentKey',
  params: { projectKey: string; segmentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/segments/:segmentKey/flags',
  params: { projectKey: string; segmentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/segments/:segmentKey/history/*',
  params: { projectKey: string; segmentKey: string; '*'?: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/segments/:segmentKey/history/:auditId/*',
  params: { projectKey: string; segmentKey: string; auditId: string; '*'?: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/segments/:segmentKey/overview',
  params: { projectKey: string; segmentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/segments/:segmentKey/settings',
  params: { projectKey: string; segmentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/segments/:segmentKey/targeting',
  params: { projectKey: string; segmentKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/segments/:segmentKey/targeting/exports/:exportKey',
  params: { projectKey: string; segmentKey: string; exportKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/segments/new', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/services/:serviceName',
  params: { projectKey: string; serviceName: string },
): string;
export function appRoute(path: '/projects/:projectKey/sessions', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/sessions/:sessionId',
  params: { projectKey: string; sessionId: string },
): string;
export function appRoute(path: '/projects/:projectKey/settings', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/settings/approvals', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/settings/context-kinds', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/settings/environments', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/settings/environments/:envKey',
  params: { projectKey: string; envKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/environments/:envKey/approval-settings',
  params: { projectKey: string; envKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/environments/:envKey/edit',
  params: { projectKey: string; envKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/environments/:envKey/keys',
  params: { projectKey: string; envKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/environments/new',
  params: { projectKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/settings/flags', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/settings/lifecycle', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/settings/model-configs', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/settings/model-configs/:configKey',
  params: { projectKey: string; configKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/settings/observability', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/settings/observability/filter-rules/:product',
  params: { projectKey: string; product: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/payload-filters',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/payload-filters/:filterKey/edit',
  params: { projectKey: string; filterKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/release-pipelines',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/release-pipelines/:releasePipelineKey',
  params: { projectKey: string; releasePipelineKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/release-pipelines/new',
  params: { projectKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/settings/releases', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/settings/releases/release-pipelines',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/releases/release-pipelines/:releasePipelineKey',
  params: { projectKey: string; releasePipelineKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/releases/release-pipelines/new',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/releases/release-policies',
  params: { projectKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/releases/release-policies/:releasePolicyKey',
  params: { projectKey: string; releasePolicyKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/releases/release-policies/new',
  params: { projectKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/settings/views', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/settings/views/:viewKey',
  params: { projectKey: string; viewKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/views/:viewKey/link',
  params: { projectKey: string; viewKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/views/:viewKey/linked-resources',
  params: { projectKey: string; viewKey: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/views/:viewKey/linked-resources/:resource',
  params: { projectKey: string; viewKey: string; resource: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/views/:viewKey/linked-resources/:resource/add',
  params: { projectKey: string; viewKey: string; resource: string },
): string;
export function appRoute(
  path: '/projects/:projectKey/settings/views/:viewKey/settings',
  params: { projectKey: string; viewKey: string },
): string;
export function appRoute(path: '/projects/:projectKey/settings/views/new', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/settings/views/settings', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/traces', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/vega', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/vega/:conversationId',
  params: { projectKey: string; conversationId: string },
): string;
export function appRoute(path: '/projects/:projectKey/vega/artifacts', params: { projectKey: string }): string;
export function appRoute(
  path: '/projects/:projectKey/vega/artifacts/:type/:externalId',
  params: { projectKey: string; type: string; externalId: string },
): string;
export function appRoute(path: '/projects/:projectKey/vega/history', params: { projectKey: string }): string;
export function appRoute(path: '/projects/:projectKey/vega/settings', params: { projectKey: string }): string;
export function appRoute(path: '/settings'): string;
export function appRoute(path: '/settings/applications'): string;
export function appRoute(path: '/settings/applications/:applicationKey', params: { applicationKey: string }): string;
export function appRoute(
  path: '/settings/applications/:applicationKey/edit',
  params: { applicationKey: string },
): string;
export function appRoute(
  path: '/settings/applications/:applicationKey/history/*',
  params: { applicationKey: string; '*'?: string },
): string;
export function appRoute(
  path: '/settings/applications/:applicationKey/versions',
  params: { applicationKey: string },
): string;
export function appRoute(
  path: '/settings/applications/:applicationKey/versions/:versionKey/support-status',
  params: { applicationKey: string; versionKey: string },
): string;
export function appRoute(
  path: '/settings/applications/:applicationKey/versions/new',
  params: { applicationKey: string },
): string;
export function appRoute(path: '/settings/applications/new'): string;
export function appRoute(path: '/settings/authorization'): string;
export function appRoute(path: '/settings/authorization/oauth'): string;
export function appRoute(path: '/settings/authorization/oauth/:appId/review', params: { appId: string }): string;
export function appRoute(path: '/settings/authorization/roles/:key', params: { key: string }): string;
export function appRoute(path: '/settings/authorization/tokens'): string;
export function appRoute(path: '/settings/authorization/tokens/:tokenId/clone', params: { tokenId: string }): string;
export function appRoute(path: '/settings/authorization/tokens/:tokenId/edit', params: { tokenId: string }): string;
export function appRoute(path: '/settings/authorization/tokens/:tokenId/reset', params: { tokenId: string }): string;
export function appRoute(path: '/settings/authorization/tokens/new'): string;
export function appRoute(path: '/settings/billing'): string;
export function appRoute(path: '/settings/billing/plans'): string;
export function appRoute(path: '/settings/billing/plans/confirmation'): string;
export function appRoute(path: '/settings/billing/plans/customize'): string;
export function appRoute(path: '/settings/billing/plans/review'): string;
export function appRoute(path: '/settings/diagnostic-usage'): string;
export function appRoute(path: '/settings/diagnostic-usage/details/:metric', params: { metric: string }): string;
export function appRoute(path: '/settings/diagnostic-usage/details/overview'): string;
export function appRoute(path: '/settings/escalate'): string;
export function appRoute(path: '/settings/general'): string;
export function appRoute(path: '/settings/history/*', params: { '*'?: string }): string;
export function appRoute(path: '/settings/integrations'): string;
export function appRoute(
  path: '/settings/integrations/:kind/:subscriptionId/edit',
  params: { kind: string; subscriptionId: string },
): string;
export function appRoute(
  path: '/settings/integrations/:kind/:subscriptionId/errors/view',
  params: { kind: string; subscriptionId: string },
): string;
export function appRoute(path: '/settings/integrations/:kind/new', params: { kind: string }): string;
export function appRoute(path: '/settings/integrations/:kind/show', params: { kind: string }): string;
export function appRoute(path: '/settings/integrations/coderefs/:id/edit', params: { id: string }): string;
export function appRoute(
  path: '/settings/integrations/destinations/:destinationId/edit',
  params: { destinationId: string },
): string;
export function appRoute(path: '/settings/integrations/destinations/new'): string;
export function appRoute(path: '/settings/integrations/sentry/show'): string;
export function appRoute(
  path: '/settings/integrations/slack/:slackHookId/edit',
  params: { slackHookId: string },
): string;
export function appRoute(path: '/settings/integrations/slack/new'): string;
export function appRoute(
  path: '/settings/integrations/webhooks/:webhookId/edit',
  params: { webhookId: string },
): string;
export function appRoute(path: '/settings/integrations/webhooks/new'): string;
export function appRoute(path: '/settings/members'): string;
export function appRoute(path: '/settings/members/:memberId', params: { memberId: string }): string;
export function appRoute(
  path: '/settings/members/:memberId/history/*',
  params: { memberId: string; '*'?: string },
): string;
export function appRoute(path: '/settings/members/:memberId/permissions', params: { memberId: string }): string;
export function appRoute(path: '/settings/members/:memberId/settings', params: { memberId: string }): string;
export function appRoute(path: '/settings/members/:memberId/teams', params: { memberId: string }): string;
export function appRoute(path: '/settings/members/invite/:inviteEmail?', params: { inviteEmail: string }): string;
export function appRoute(path: '/settings/plan-usage'): string;
export function appRoute(path: '/settings/plan-usage/details/:metric', params: { metric: string }): string;
export function appRoute(path: '/settings/plan-usage/details/overview'): string;
export function appRoute(path: '/settings/profile'): string;
export function appRoute(path: '/settings/projects'): string;
export function appRoute(path: '/settings/relay'): string;
export function appRoute(path: '/settings/relay/:id/edit', params: { id: string }): string;
export function appRoute(path: '/settings/relay/new'): string;
export function appRoute(path: '/settings/roles'): string;
export function appRoute(path: '/settings/roles/:key/edit', params: { key: string }): string;
export function appRoute(path: '/settings/roles/:key/view', params: { key: string }): string;
export function appRoute(path: '/settings/roles/new'): string;
export function appRoute(path: '/settings/roles/organization'): string;
export function appRoute(path: '/settings/roles/organization/:key/view', params: { key: string }): string;
export function appRoute(path: '/settings/roles/project'): string;
export function appRoute(path: '/settings/roles/project/:key/view', params: { key: string }): string;
export function appRoute(path: '/settings/sdk-keys'): string;
export function appRoute(path: '/settings/sdks'): string;
export function appRoute(path: '/settings/sdks/:applicationId', params: { applicationId: string }): string;
export function appRoute(path: '/settings/security'): string;
export function appRoute(path: '/settings/security/saml/config'): string;
export function appRoute(path: '/settings/teams'): string;
export function appRoute(path: '/settings/teams/:teamKey', params: { teamKey: string }): string;
export function appRoute(path: '/settings/teams/:teamKey/history/*', params: { teamKey: string; '*'?: string }): string;
export function appRoute(path: '/settings/teams/:teamKey/members', params: { teamKey: string }): string;
export function appRoute(path: '/settings/teams/:teamKey/permissions', params: { teamKey: string }): string;
export function appRoute(path: '/settings/teams/:teamKey/settings', params: { teamKey: string }): string;
export function appRoute(path: '/settings/token-limits'): string;
export function appRoute(path: '/settings/tokens/*', params: { '*'?: string }): string;
export function appRoute(path: '/settings/usage'): string;
export function appRoute(path: '/settings/usage/details/*', params: { '*'?: string }): string;
export function appRoute(path: '/verify-email'): string;
export function appRoute(path: string, params?: Params<string>) {
  return generatePath(path, params);
}

/**
 * Defines the ownership for all the routes defined in ../../../static/ld/routes/appRoutes.tsx.
 *
 */
export type AppRouteOwnership = {
  '/': Squad;
  '/*': Squad;
  '/confirm-auth/:deviceCode': Squad;
  '/confirm-your-email': Squad;
  '/insights': Squad;
  '/internal/new-hires': Squad;
  '/launchlitely': Squad;
  '/launchlitely/:projectKey': Squad;
  '/product-analytics/integrations/:warehouseId': Squad;
  '/profile': Squad;
  '/projects/:projectKey': Squad;
  '/projects/:projectKey/agentcontrol': Squad;
  '/projects/:projectKey/agentcontrol-welcome': Squad;
  '/projects/:projectKey/agentcontrol-welcome/setup-sdk': Squad;
  '/projects/:projectKey/ai': Squad;
  '/projects/:projectKey/ai-configs': Squad;
  '/projects/:projectKey/ai-configs/:configKey': Squad;
  '/projects/:projectKey/ai-configs/:configKey/monitoring': Squad;
  '/projects/:projectKey/ai-configs/:configKey/playground': Squad;
  '/projects/:projectKey/ai-configs/:configKey/targeting': Squad;
  '/projects/:projectKey/ai-configs/:configKey/targeting/pending-changes': Squad;
  '/projects/:projectKey/ai-configs/:configKey/variations': Squad;
  '/projects/:projectKey/ai-configs/:configKey/variations/:variationKey': Squad;
  '/projects/:projectKey/ai-configs/new': Squad;
  '/projects/:projectKey/ai-library': Squad;
  '/projects/:projectKey/ai-library/datasets': Squad;
  '/projects/:projectKey/ai-library/datasets/:datasetKey': Squad;
  '/projects/:projectKey/ai-library/judge-templates': Squad;
  '/projects/:projectKey/ai-library/judge-templates/:templateKey': Squad;
  '/projects/:projectKey/ai-library/models': Squad;
  '/projects/:projectKey/ai-library/models/:configKey': Squad;
  '/projects/:projectKey/ai-library/skills': Squad;
  '/projects/:projectKey/ai-library/snippets': Squad;
  '/projects/:projectKey/ai-library/snippets/:snippetKey': Squad;
  '/projects/:projectKey/ai-library/snippets/new': Squad;
  '/projects/:projectKey/ai-library/tool/:toolKey': Squad;
  '/projects/:projectKey/ai-library/tools': Squad;
  '/projects/:projectKey/ai-monitoring': Squad;
  '/projects/:projectKey/ai-monitoring/trends': Squad;
  '/projects/:projectKey/ai/evaluation': Squad;
  '/projects/:projectKey/ai/evaluations': Squad;
  '/projects/:projectKey/ai/evaluations/:evaluationId/runs/:runId': Squad;
  '/projects/:projectKey/ai/graphs': Squad;
  '/projects/:projectKey/ai/graphs/:graphKey': Squad;
  '/projects/:projectKey/ai/optimize-agent': Squad;
  '/projects/:projectKey/ai/optimize-agent/:optimizationId': Squad;
  '/projects/:projectKey/ai/optimize-agent/:optimizationId/configuration': Squad;
  '/projects/:projectKey/ai/optimize-agent/:optimizationId/runs': Squad;
  '/projects/:projectKey/ai/optimize-agent/:optimizationId/runs/:runId': Squad;
  '/projects/:projectKey/ai/optimize-agent/new': Squad;
  '/projects/:projectKey/ai/playgrounds': Squad;
  '/projects/:projectKey/ai/playgrounds/:evaluationId': Squad;
  '/projects/:projectKey/ai/playgrounds/active': Squad;
  '/projects/:projectKey/ai/playgrounds/archived': Squad;
  '/projects/:projectKey/alerts': Squad;
  '/projects/:projectKey/alerts/:alertId': Squad;
  '/projects/:projectKey/alerts/:alertId/edit': Squad;
  '/projects/:projectKey/alerts/new': Squad;
  '/projects/:projectKey/approvals': Squad;
  '/projects/:projectKey/approvals/:approvalRequestId': Squad;
  '/projects/:projectKey/audit': Squad;
  '/projects/:projectKey/audit/:auditId/*': Squad;
  '/projects/:projectKey/compare': Squad;
  '/projects/:projectKey/compare/:environmentPair': Squad;
  '/projects/:projectKey/compare/:environmentPair/flags/:flagKey': Squad;
  '/projects/:projectKey/contexts': Squad;
  '/projects/:projectKey/contexts/instances/:instanceId': Squad;
  '/projects/:projectKey/contexts/kinds': Squad;
  '/projects/:projectKey/contexts/kinds/:kind/instances/:key': Squad;
  '/projects/:projectKey/dashboards': Squad;
  '/projects/:projectKey/dashboards/:dashboardId': Squad;
  '/projects/:projectKey/dashboards/:dashboardId/:graphId': Squad;
  '/projects/:projectKey/dashboards/:dashboardId/:graphId/edit': Squad;
  '/projects/:projectKey/dashboards/:dashboardId/new': Squad;
  '/projects/:projectKey/dashboards/new': Squad;
  '/projects/:projectKey/data-sources': Squad;
  '/projects/:projectKey/data-sources/assignments': Squad;
  '/projects/:projectKey/data-sources/assignments/:dataSourceKey': Squad;
  '/projects/:projectKey/data-sources/assignments/:dataSourceKey/configuration': Squad;
  '/projects/:projectKey/data-sources/assignments/:dataSourceKey/connections': Squad;
  '/projects/:projectKey/data-sources/assignments/new': Squad;
  '/projects/:projectKey/data-sources/metrics': Squad;
  '/projects/:projectKey/data-sources/metrics/:dataSourceKey': Squad;
  '/projects/:projectKey/data-sources/metrics/:dataSourceKey/configuration': Squad;
  '/projects/:projectKey/data-sources/metrics/:dataSourceKey/connections': Squad;
  '/projects/:projectKey/data-sources/metrics/new': Squad;
  '/projects/:projectKey/errors': Squad;
  '/projects/:projectKey/errors/:issueId': Squad;
  '/projects/:projectKey/errors/:issueId/instances': Squad;
  '/projects/:projectKey/errors/:issueId/instances/:instanceId': Squad;
  '/projects/:projectKey/experiments': Squad;
  '/projects/:projectKey/experiments/:experimentId/details': Squad;
  '/projects/:projectKey/experiments/:experimentKey': Squad;
  '/projects/:projectKey/experiments/:experimentKey/analytics': Squad;
  '/projects/:projectKey/experiments/:experimentKey/design': Squad;
  '/projects/:projectKey/experiments/:experimentKey/design/pending-changes': Squad;
  '/projects/:projectKey/experiments/:experimentKey/download-pdf': Squad;
  '/projects/:projectKey/experiments/:experimentKey/exposures': Squad;
  '/projects/:projectKey/experiments/:experimentKey/iterations': Squad;
  '/projects/:projectKey/experiments/:experimentKey/iterations/:iterationId': Squad;
  '/projects/:projectKey/experiments/:experimentKey/results': Squad;
  '/projects/:projectKey/experiments/:experimentKey/results/pending-changes': Squad;
  '/projects/:projectKey/experiments/:experimentKey/traffic': Squad;
  '/projects/:projectKey/experiments/new': Squad;
  '/projects/:projectKey/factory/release-coordinator': Squad;
  '/projects/:projectKey/flags': Squad;
  '/projects/:projectKey/flags/:flagKey': Squad;
  '/projects/:projectKey/flags/:flagKey/add-to-code': Squad;
  '/projects/:projectKey/flags/:flagKey/approvals/:approvalRequestId': Squad;
  '/projects/:projectKey/flags/:flagKey/audience': Squad;
  '/projects/:projectKey/flags/:flagKey/code-refs': Squad;
  '/projects/:projectKey/flags/:flagKey/environment-overview': Squad;
  '/projects/:projectKey/flags/:flagKey/environments': Squad;
  '/projects/:projectKey/flags/:flagKey/environments/exclude-rules': Squad;
  '/projects/:projectKey/flags/:flagKey/experiments/*': Squad;
  '/projects/:projectKey/flags/:flagKey/feedback': Squad;
  '/projects/:projectKey/flags/:flagKey/history': Squad;
  '/projects/:projectKey/flags/:flagKey/history/:auditId/*': Squad;
  '/projects/:projectKey/flags/:flagKey/insights': Squad;
  '/projects/:projectKey/flags/:flagKey/links': Squad;
  '/projects/:projectKey/flags/:flagKey/monitoring': Squad;
  '/projects/:projectKey/flags/:flagKey/settings': Squad;
  '/projects/:projectKey/flags/:flagKey/settings/archive': Squad;
  '/projects/:projectKey/flags/:flagKey/settings/deprecate': Squad;
  '/projects/:projectKey/flags/:flagKey/targeting': Squad;
  '/projects/:projectKey/flags/:flagKey/targeting/conflicts/:conflictIndex': Squad;
  '/projects/:projectKey/flags/:flagKey/targeting/exclude-rules': Squad;
  '/projects/:projectKey/flags/:flagKey/targeting/expiring-targets': Squad;
  '/projects/:projectKey/flags/:flagKey/targeting/expiring-targets/:expiringId': Squad;
  '/projects/:projectKey/flags/:flagKey/targeting/pending-changes': Squad;
  '/projects/:projectKey/flags/:flagKey/targeting/pending-changes/:pendingId': Squad;
  '/projects/:projectKey/flags/:flagKey/variations': Squad;
  '/projects/:projectKey/flags/:flagKey/variations/conflicts/:conflictIndex': Squad;
  '/projects/:projectKey/flags/:flagKey/variations/pending-changes': Squad;
  '/projects/:projectKey/flags/:flagKey/variations/pending-changes/:pendingId': Squad;
  '/projects/:projectKey/flags/:flagKey/workflows': Squad;
  '/projects/:projectKey/flags/:flagKey/workflows/:workflowId': Squad;
  '/projects/:projectKey/flags/:flagKey/workflows/new': Squad;
  '/projects/:projectKey/flags/connect': Squad;
  '/projects/:projectKey/flags/new': Squad;
  '/projects/:projectKey/get-started': Squad;
  '/projects/:projectKey/get-started/invite-members': Squad;
  '/projects/:projectKey/get-started/quickstart': Squad;
  '/projects/:projectKey/get-started/setup-cli': Squad;
  '/projects/:projectKey/guarded-rollouts': Squad;
  '/projects/:projectKey/holdouts': Squad;
  '/projects/:projectKey/holdouts/:holdoutKey': Squad;
  '/projects/:projectKey/holdouts/:holdoutKey/design': Squad;
  '/projects/:projectKey/holdouts/:holdoutKey/details': Squad;
  '/projects/:projectKey/holdouts/new': Squad;
  '/projects/:projectKey/home': Squad;
  '/projects/:projectKey/live': Squad;
  '/projects/:projectKey/live/flags/:flagKey': Squad;
  '/projects/:projectKey/logs': Squad;
  '/projects/:projectKey/metric-data-sources': Squad;
  '/projects/:projectKey/metric-data-sources/:dataSourceKey/details': Squad;
  '/projects/:projectKey/metric-data-sources/new': Squad;
  '/projects/:projectKey/metrics': Squad;
  '/projects/:projectKey/metrics/:metricKey/details': Squad;
  '/projects/:projectKey/metrics/groups': Squad;
  '/projects/:projectKey/metrics/groups/:metricGroupKey/details': Squad;
  '/projects/:projectKey/metrics/groups/new': Squad;
  '/projects/:projectKey/metrics/new': Squad;
  '/projects/:projectKey/multi-armed-bandits': Squad;
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey': Squad;
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/design': Squad;
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/exposures': Squad;
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/iterations': Squad;
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/iterations/:iterationId': Squad;
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/results': Squad;
  '/projects/:projectKey/multi-armed-bandits/new': Squad;
  '/projects/:projectKey/observability-metrics': Squad;
  '/projects/:projectKey/observe': Squad;
  '/projects/:projectKey/observe/expand/:dataSourceKey/:eventKind/:eventKey': Squad;
  '/projects/:projectKey/observe/new-metric': Squad;
  '/projects/:projectKey/product-analytics': Squad;
  '/projects/:projectKey/product-analytics/charts': Squad;
  '/projects/:projectKey/product-analytics/charts/:id': Squad;
  '/projects/:projectKey/product-analytics/charts/new': Squad;
  '/projects/:projectKey/product-analytics/cohorts': Squad;
  '/projects/:projectKey/product-analytics/cohorts/:id': Squad;
  '/projects/:projectKey/product-analytics/cohorts/:id/edit': Squad;
  '/projects/:projectKey/product-analytics/cohorts/new': Squad;
  '/projects/:projectKey/product-analytics/dashboards': Squad;
  '/projects/:projectKey/product-analytics/dashboards/:id': Squad;
  '/projects/:projectKey/product-analytics/dashboards/new': Squad;
  '/projects/:projectKey/product-analytics/events': Squad;
  '/projects/:projectKey/product-analytics/user-activity': Squad;
  '/projects/:projectKey/product-analytics/user-attributes': Squad;
  '/projects/:projectKey/product-analytics/visualizations/:id': Squad;
  '/projects/:projectKey/product-analytics/visualizations/new': Squad;
  '/projects/:projectKey/releases': Squad;
  '/projects/:projectKey/releases/:releasePipelineKey': Squad;
  '/projects/:projectKey/sdk-setup': Squad;
  '/projects/:projectKey/segments': Squad;
  '/projects/:projectKey/segments/:segmentKey': Squad;
  '/projects/:projectKey/segments/:segmentKey/flags': Squad;
  '/projects/:projectKey/segments/:segmentKey/history/*': Squad;
  '/projects/:projectKey/segments/:segmentKey/history/:auditId/*': Squad;
  '/projects/:projectKey/segments/:segmentKey/overview': Squad;
  '/projects/:projectKey/segments/:segmentKey/settings': Squad;
  '/projects/:projectKey/segments/:segmentKey/targeting': Squad;
  '/projects/:projectKey/segments/:segmentKey/targeting/exports/:exportKey': Squad;
  '/projects/:projectKey/segments/new': Squad;
  '/projects/:projectKey/services/:serviceName': Squad;
  '/projects/:projectKey/sessions': Squad;
  '/projects/:projectKey/sessions/:sessionId': Squad;
  '/projects/:projectKey/settings': Squad;
  '/projects/:projectKey/settings/approvals': Squad;
  '/projects/:projectKey/settings/context-kinds': Squad;
  '/projects/:projectKey/settings/environments': Squad;
  '/projects/:projectKey/settings/environments/:envKey': Squad;
  '/projects/:projectKey/settings/environments/:envKey/approval-settings': Squad;
  '/projects/:projectKey/settings/environments/:envKey/edit': Squad;
  '/projects/:projectKey/settings/environments/:envKey/keys': Squad;
  '/projects/:projectKey/settings/environments/new': Squad;
  '/projects/:projectKey/settings/flags': Squad;
  '/projects/:projectKey/settings/lifecycle': Squad;
  '/projects/:projectKey/settings/model-configs': Squad;
  '/projects/:projectKey/settings/model-configs/:configKey': Squad;
  '/projects/:projectKey/settings/observability': Squad;
  '/projects/:projectKey/settings/observability/filter-rules/:product': Squad;
  '/projects/:projectKey/settings/payload-filters': Squad;
  '/projects/:projectKey/settings/payload-filters/:filterKey/edit': Squad;
  '/projects/:projectKey/settings/release-pipelines': Squad;
  '/projects/:projectKey/settings/release-pipelines/:releasePipelineKey': Squad;
  '/projects/:projectKey/settings/release-pipelines/new': Squad;
  '/projects/:projectKey/settings/releases': Squad;
  '/projects/:projectKey/settings/releases/release-pipelines': Squad;
  '/projects/:projectKey/settings/releases/release-pipelines/:releasePipelineKey': Squad;
  '/projects/:projectKey/settings/releases/release-pipelines/new': Squad;
  '/projects/:projectKey/settings/releases/release-policies': Squad;
  '/projects/:projectKey/settings/releases/release-policies/:releasePolicyKey': Squad;
  '/projects/:projectKey/settings/releases/release-policies/new': Squad;
  '/projects/:projectKey/settings/views': Squad;
  '/projects/:projectKey/settings/views/:viewKey': Squad;
  '/projects/:projectKey/settings/views/:viewKey/link': Squad;
  '/projects/:projectKey/settings/views/:viewKey/linked-resources': Squad;
  '/projects/:projectKey/settings/views/:viewKey/linked-resources/:resource': Squad;
  '/projects/:projectKey/settings/views/:viewKey/linked-resources/:resource/add': Squad;
  '/projects/:projectKey/settings/views/:viewKey/settings': Squad;
  '/projects/:projectKey/settings/views/new': Squad;
  '/projects/:projectKey/settings/views/settings': Squad;
  '/projects/:projectKey/traces': Squad;
  '/projects/:projectKey/vega': Squad;
  '/projects/:projectKey/vega/:conversationId': Squad;
  '/projects/:projectKey/vega/artifacts': Squad;
  '/projects/:projectKey/vega/artifacts/:type/:externalId': Squad;
  '/projects/:projectKey/vega/history': Squad;
  '/projects/:projectKey/vega/settings': Squad;
  '/settings': Squad;
  '/settings/applications': Squad;
  '/settings/applications/:applicationKey': Squad;
  '/settings/applications/:applicationKey/edit': Squad;
  '/settings/applications/:applicationKey/history/*': Squad;
  '/settings/applications/:applicationKey/versions': Squad;
  '/settings/applications/:applicationKey/versions/:versionKey/support-status': Squad;
  '/settings/applications/:applicationKey/versions/new': Squad;
  '/settings/applications/new': Squad;
  '/settings/authorization': Squad;
  '/settings/authorization/oauth': Squad;
  '/settings/authorization/oauth/:appId/review': Squad;
  '/settings/authorization/roles/:key': Squad;
  '/settings/authorization/tokens': Squad;
  '/settings/authorization/tokens/:tokenId/clone': Squad;
  '/settings/authorization/tokens/:tokenId/edit': Squad;
  '/settings/authorization/tokens/:tokenId/reset': Squad;
  '/settings/authorization/tokens/new': Squad;
  '/settings/billing': Squad;
  '/settings/billing/plans': Squad;
  '/settings/billing/plans/confirmation': Squad;
  '/settings/billing/plans/customize': Squad;
  '/settings/billing/plans/review': Squad;
  '/settings/diagnostic-usage': Squad;
  '/settings/diagnostic-usage/details/:metric': Squad;
  '/settings/diagnostic-usage/details/overview': Squad;
  '/settings/escalate': Squad;
  '/settings/general': Squad;
  '/settings/history/*': Squad;
  '/settings/integrations': Squad;
  '/settings/integrations/:kind/:subscriptionId/edit': Squad;
  '/settings/integrations/:kind/:subscriptionId/errors/view': Squad;
  '/settings/integrations/:kind/new': Squad;
  '/settings/integrations/:kind/show': Squad;
  '/settings/integrations/coderefs/:id/edit': Squad;
  '/settings/integrations/destinations/:destinationId/edit': Squad;
  '/settings/integrations/destinations/new': Squad;
  '/settings/integrations/sentry/show': Squad;
  '/settings/integrations/slack/:slackHookId/edit': Squad;
  '/settings/integrations/slack/new': Squad;
  '/settings/integrations/webhooks/:webhookId/edit': Squad;
  '/settings/integrations/webhooks/new': Squad;
  '/settings/members': Squad;
  '/settings/members/:memberId': Squad;
  '/settings/members/:memberId/history/*': Squad;
  '/settings/members/:memberId/permissions': Squad;
  '/settings/members/:memberId/settings': Squad;
  '/settings/members/:memberId/teams': Squad;
  '/settings/members/invite/:inviteEmail?': Squad;
  '/settings/plan-usage': Squad;
  '/settings/plan-usage/details/:metric': Squad;
  '/settings/plan-usage/details/overview': Squad;
  '/settings/profile': Squad;
  '/settings/projects': Squad;
  '/settings/relay': Squad;
  '/settings/relay/:id/edit': Squad;
  '/settings/relay/new': Squad;
  '/settings/roles': Squad;
  '/settings/roles/:key/edit': Squad;
  '/settings/roles/:key/view': Squad;
  '/settings/roles/new': Squad;
  '/settings/roles/organization': Squad;
  '/settings/roles/organization/:key/view': Squad;
  '/settings/roles/project': Squad;
  '/settings/roles/project/:key/view': Squad;
  '/settings/sdk-keys': Squad;
  '/settings/sdks': Squad;
  '/settings/sdks/:applicationId': Squad;
  '/settings/security': Squad;
  '/settings/security/saml/config': Squad;
  '/settings/teams': Squad;
  '/settings/teams/:teamKey': Squad;
  '/settings/teams/:teamKey/history/*': Squad;
  '/settings/teams/:teamKey/members': Squad;
  '/settings/teams/:teamKey/permissions': Squad;
  '/settings/teams/:teamKey/settings': Squad;
  '/settings/token-limits': Squad;
  '/settings/tokens/*': Squad;
  '/settings/usage': Squad;
  '/settings/usage/details/*': Squad;
  '/verify-email': Squad;
};

/**
 * This type defines any possible route, as a union type of all routes defined in:
 *   - ../../../static/ld/routes/unauthenticatedRoutes.tsx
 *   - ../../../static/ld/routes/appRoutes.tsx
 *
 */
export type AnyRoute = UnauthenticatedRoute | AppRoute;
